<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ShippingDestinyTransportationForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ShippingDestinyTransportationForm from "@/components/settings/test-registers/shippingdestinytransportation/ShippingDestinyTransportationForm";

export default {
  name: "ShippingDestinyTransportationAdd",
  components: {
    PageTitle,
    PageRowWrapper,
    ShippingDestinyTransportationForm,
  },
};
</script>
